/**
 * Created with IntelliJ IDEA.
 * User: sronge
 * Date: 08.08.13
 * Time: 11:48
 * To change this template use File | Settings | File Templates.
 */


import { BasicProperties } from "../BasicProperties";
import { Localize } from "@goodgamestudios/localization";

export class BasicMissingIDCheckDialogProperties extends BasicProperties {
    public buttonLabel_IDckeck: string = "ID-Check";
    public title: string = "";
    public copy: string = "";
    public functionCheckID: Function;
    public functionCancel: Function;

    constructor(title: string, copy: string, functionCheckID: Function = null, buttonLabel_IDckeck: string = "", functionCancel: Function = null) {
        super();
        this.functionCheckID = functionCheckID;
        this.functionCancel = functionCancel;

        if (buttonLabel_IDckeck.length > 0) {
            this.buttonLabel_IDckeck = buttonLabel_IDckeck;
        }
        else {
            this.buttonLabel_IDckeck = this.delegateText("generic_btn_korea_idcheck");
        }

        this.title = title;
        this.copy = copy;
    }

    protected delegateText(textId: string): string {
        return Localize.text(textId);
    }
}

